"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const form_1 = require("../form");
const form_context_1 = require("./form-context");
const lodash_1 = require("lodash");
function withFormField(Component) {
    return class EditableField extends React.Component {
        render() {
            const { message } = this.props;
            return (React.createElement(form_context_1.FormContext.Consumer, null, ({ isSubmitting }) => (React.createElement(form_1.Field, Object.assign({}, this.props), ({ fieldProps, error, meta }) => (React.createElement(React.Fragment, null,
                React.createElement(Component, Object.assign({ isDisabled: isSubmitting }, fieldProps, lodash_1.omit(this.props, "defaultValue"))),
                message && message({ error, meta })))))));
        }
    };
}
exports.withFormField = withFormField;
